import type { MonthAbbr } from '../types';

import { MONTH_ORDER, THAI_MONTH_NAMES } from './constants';

export function getMonthOrder(monthAbbr: string) {
  return MONTH_ORDER.indexOf(monthAbbr.toUpperCase() as MonthAbbr);
}

function getThaiMonthName(monthAbbr: string): string {
  // Convert to uppercase to handle case insensitivity
  const normalizedMonthAbbr = monthAbbr.toUpperCase() as MonthAbbr;

  // Return the Thai month name or the original input if not found
  return THAI_MONTH_NAMES[normalizedMonthAbbr] ?? monthAbbr;
}

export function getExamEventScheduleTitle(year: number, month: string) {
  const thaiMonth = getThaiMonthName(month);

  return `ตารางสอบเดือน${thaiMonth}/${year}`;
}

export function getExamEventDetailsTitle(year: number, month: string): string {
  const thaiMonth = getThaiMonthName(month);

  return `เดือน${thaiMonth}/${year}`;
}

/**
 * Validates if the provided string is a valid month abbreviation
 * @param monthAbbr The month abbreviation to validate (e.g., 'JAN', 'FEB')
 * @returns True if the abbreviation is valid, false otherwise
 */
export function isValidMonthAbbr(monthAbbr: string): boolean {
  if (!monthAbbr || typeof monthAbbr !== 'string') {
    return false;
  }

  // Check if the normalized abbreviation exists in our mapping
  return MONTH_ORDER.includes(monthAbbr as MonthAbbr);
}
